<template>
  <l-tela titulo="Clientes">
    <l-consulta
      :colunas="colunas"
      :registros="registros"
      :totalPaginas="paginas"
      @cliqueLinha="abrirAlteracao"
      @buscarPagina="buscar"
    />
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          fab
          large
          fixed
          bottom
          right
          v-bind="attrs"
          v-on="on"
          @click="abrirCadastro"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Adicionar novo cliente</span>
    </v-tooltip>
  </l-tela>
</template>

<script>
import clienteService from '@/services/cliente.service'
import LoadingMixin from '@/components/Mixins/Loading'
import NotificacaoMixin from '@/components/Mixins/Notificacao'

export default {
  mixins: [LoadingMixin, NotificacaoMixin],
  data() {
    return {
      colunas: [
        {
          text: 'Nome do cliente',
          align: 'start',
          sortable: false,
          value: 'nome',
          width: 500,
        },
        { text: 'Contato', value: 'contato' },
      ],
      registros: [],
      paginas: 0,
    }
  },
  mounted() {
    this.buscar()
  },
  methods: {
    abrirCadastro() {
      this.$router.push({ name: 'rota-cliente-cadastrar' })
    },
    abrirAlteracao(registro) {
      const { _id } = registro
      if (_id) {
        this.$router.push({
          name: 'rota-cliente-alterar',
          params: { clienteId: _id },
        })
      }
    },
    async buscar(pagina = 1) {
      this.mostrarLoading()
      try {
        const cliente = await clienteService.buscaTodos(pagina)
        this.registros = cliente.lista
        this.paginas = cliente.pages
      } catch (error) {
        this.mostraNotificacao(error)
      } finally {
        this.fecharLoading()
      }
    },
  },
}
</script>
